/** Standalone `/signin` (or similar) vs embedded checkout login. */
export type SignInFlow = 'standalone' | 'checkout';

export const SIGNIN_REDIRECT_COOKIE_KEY = '__rdSI';
export const CHECKOUT_REDIRECT_COOKIE_KEY = '__rdCO';
